<template>
  <v-layout class="network_header">
    <v-flex>
      <v-flex class="network_header__breadcrumb" v-if="isVisible">
        <v-breadcrumbs :items="breadcrumbsList" divider=">">
          <template slot="item" slot-scope="props">
            <router-link :to="props.item.routeName" class="network_header__breadcrumb--name">
              {{ props.item.name }}
            </router-link>
          </template>
        </v-breadcrumbs>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap :class="layoutClasses">
          <div class="network_header__header" v-if="isVisible">
            <div class="network_header__header--name" data-qe-id="network_header-name">{{ communityName }}</div>
            <div class="network_header__header--tagline" >
              <div data-qe-id="network_header-tagline" class="edit-desc">{{ communityTagLine }}</div>
              <i v-if="canEditContent" :data-qe-id="`network_header_tagline_dialog`"
                 class="fas fa-pencil-alt edit-icon" @click="openEditHeaderDialog(networkLandingCategoryType.COMMUNITY_TAG_LINE, networkLandingCategoryType.DESCRIPTION)"
              ></i>
            </div>
              <div class="network_header__header--btn" v-if="joinNetworkButtonText">
                <v-btn class="primary_btn small edit-btn" data-qe-id="network_header-join-the-network"
                       @click="navigateToNetworkPage(communityId)">
                  {{ joinNetworkButtonText }}
                </v-btn>
                <i v-if="canEditContent" :data-qe-id="`network_header_btn_dialog`"
                   class="fas fa-pencil-alt edit-icon" @click="openEditHeaderDialog( networkLandingCategoryType.JOIN_NETWORK_BUTTON_TEXT, networkLandingCategoryType.BUTTON)"
                ></i>

              </div>
          </div>
        </v-layout>
      </v-flex>

    </v-flex>
    <v-dialog v-model="networkHeaderEditDialog" content-class="small" persistent scrollable>
      <v-card class="categoryEdit-popup">
        <div v-if="isSaveInProgress" class="disabled-overlay"></div>
        <v-card-title primary-title>
          {{ headerLabel }}
          <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="closeNetworkHeaderDialog" />
        </v-card-title>
        <v-card-text class="inner-scrollbar">
          <v-form ref="networkHeaderDialog" class="relative-position" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex class="details-view">
                <span class="select-label">{{ ypoNetworkMenuDialogFields.DIALOG_CATEGORY_LABEL }}</span>
                <v-text-field v-model="networkContentEditModel.value"
                              :maxlength="[contentType === networkLandingCategoryType.JOIN_NETWORK_BUTTON_TEXT
                              ? ypoNetworkValidationRules.BUTTON_NAME_MAX_TEXT_LENGTH
                              : ypoNetworkValidationRules.HEADER_DESC_MAX_TEXT_LENGTH
                              ]"
                              :rules="ypoNetworkValidationRules.CATEGORY_LABEL_RULE" autofocus color="ypo_blue" required />
                <span class="select-label" v-if="contentType === networkLandingCategoryType.JOIN_NETWORK_BUTTON_TEXT">{{ ypoNetworkMenuDialogFields.DIALOG_LINK }}</span>
                <v-text-field v-if="contentType === networkLandingCategoryType.JOIN_NETWORK_BUTTON_TEXT" v-model="networkContentEditModel.url"
                              :placeholder="networkContentEditModel.navigationUrl"
                              :rules="ypoNetworkValidationRules.HEADER_NAVIGATION_URL_RULE"
                              color="ypo_blue" />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-layout pb-2 pt-1 row wrap class="relative-position">
            <v-flex pa-3 text-xs-right>
              <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn" flat small
                     @click="closeNetworkHeaderDialog">
                {{ appCommonConstants.CANCEL }}
              </v-btn>
              <v-btn class="primary_btn" data-qe-id="save_dialog_btn" :disabled="!isFormValid || isSaveInProgress"
                     @click="saveContent">
                {{ appCommonConstants.SAVE }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { storeGetters } from "@/store/storeGetters.constant";
import { appCommonConstants, routerNames, userRoles } from "../appCommon.constants";
import {
  getNetworkContentModel,
  NetworkConstants,
  networkLandingCategoryType,
  ypoNetworkMenuDialogFields,
  ypoNetworkValidationRules
} from "./NetworkConstants";
import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import {storeAction} from "@/store/storeActions.constant";

export default {
  name: 'NetworkHeader',
  components: {
  },
  data: () => ({
    NetworkConstants,
    userRoles,
    networkHeaderEditDialog: false,
    appCommonConstants,
    headerLabel: '',
    valid: false,
    isSaveInProgress: false,
    contentType: '',
    deleteTriggered: false,
    displayDeleteButton: false,
    networkContentEditModel: getNetworkContentModel(),
    ypoNetworkMenuDialogFields,
    ypoNetworkValidationRules
  }),
  computed: {
    networkLandingCategoryType() {
      return networkLandingCategoryType
    },
    ...mapGetters({
      networkPageContent: `network/${storeGetters.networkPageContent}`,
      communityInfo: `chapter/${storeGetters.communityInfo}`,
      isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
      permissionsData: `auth/${storeGetters.permissionsData}`,
    }),
    layoutClasses() {
      return {
        'justify-center': !this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs,
      };
    },
    canEditContent() {
      return this.permissionsData.canEditNetworkPageContent || (this.communityInfo &&
        this.communityInfo.communityId === this.$route.params.communityId &&
        this.communityInfo.userAccess &&
        this.communityInfo.userAccess.canEditNetworkPageContent);
    },
    communityType() {
      return this.$route.name;
    },
    communityCategory() {
      return this.networkPageContent && this.networkPageContent.communityFocus
          ? this.networkPageContent.communityFocus : "";
    },
    communityName() {
      if (this.networkPageContent && this.networkPageContent.communityName) {
        return this.networkPageContent.communityName;
      }
      
      if (this.communityInfo && this.communityInfo.name) {
        return this.communityInfo.name;
      }

      return "";
    },
    communityTagLine() {
      return this.getCommunityTagLine();
    },
    joinNetworkButtonText() {
      return this.networkPageContent && this.networkPageContent.joinNetworkButtonText && this.networkPageContent.joinNetworkButtonText.value
        ? this.networkPageContent.joinNetworkButtonText.value : NetworkConstants.JOIN_THE_NETWORK;
    },
    communityId() {
      return this.networkPageContent && this.networkPageContent.communityId
          ? this.networkPageContent.communityId : "";
    },
    isVisible() {
      return this.$route.params.communityId !== undefined;
    },
    breadcrumbsList() {
      const resultArray = [];
      resultArray.push({
        name: NetworkConstants.NETWORK_HEADING,
        routeName: `/${routerNames.ALL_NETWORKS_PAGE}`,
        disabled: false,
      });
      if (this.networkPageContent && this.networkPageContent.communityFocus) {
        resultArray.push({
          name: this.networkPageContent && this.networkPageContent.communityFocus ? this.networkPageContent.communityFocus : "",
          routeName: `/${routerNames.ALL_NETWORKS_PAGE}`,
          disabled: false,
        });
      } else if(this.communityInfo) {
        resultArray.push({
          name: this.communityInfo.communitySubType || "",
          routeName: `/${routerNames.ALL_NETWORKS_PAGE}`,
          disabled: false,
        });
      }
      return resultArray;
    },
    isFormValid() {
      // Trigger validation for all fields
      if (this.$refs.networkHeaderDialog && !this.isSaveInProgress) {
        this.$refs.networkHeaderDialog.validate();
      }
      return this.valid;
    },
  },
  methods: {
    ...mapActions({
      getNetworkPageContent: `network/${storeAction.getNetworkPageContent}`,
      saveYpoNetworkCategories: `network/${storeAction.saveYpoNetworkCategories}`,
    }),
    navigateToNetworkPage(communityId) {
      if (this.networkPageContent.joinNetworkButtonText.url){
        if (this.networkPageContent.joinNetworkButtonText.url.startsWith("mailto:")) {
          window.location.href = this.networkPageContent.joinNetworkButtonText.url;
        }
        const appOrigin = window.location.origin;
        let url = this.networkPageContent.joinNetworkButtonText.url;
        if (!url.includes('http')) {
          url = `https://${url}`;
        }
        if (url.includes(appOrigin) || (this.isMobileAppBrowser)) {
          window.open(url, "_self");
        } else {
          window.open(url, "_blank");
        }
      } else {
        const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
        if (hbRedirectCommunity) {
          const target = this.isMobileAppBrowser ? '_self' : '_blank';
          window.open(hbRedirectCommunity.redirectUrl, target);
        } else {
          this.$router.push(`/${routerNames.NETWORK}/${communityId}`);
        }
        gaDataLayerEvent(gtmEventName.C_Network_Page_Selected_Network, communityId);
      }
    },
    openEditHeaderDialog(contentType, type) {
      this.networkHeaderEditDialog = true;
      this.contentType = contentType;
      this.headerLabel = '';
      const categoryData = this.networkPageContent[contentType] || [];
      const valueFallbackMap = {
        communityTagLine: NetworkConstants.ADD_NETWORK_DESCRIPTION,
      };
      const defaultValue = valueFallbackMap[contentType] || NetworkConstants.JOIN_THE_NETWORK;
      this.networkContentEditModel = {
        communityId: this.communityId,
        categoryId: (categoryData && categoryData.categoryId) ? categoryData.categoryId : this.getCategoryId(contentType),
        categoryName: categoryData ? categoryData.categoryName : '',
        id: categoryData ? categoryData.id : '',
        value: (categoryData && categoryData.value) ? categoryData.value: defaultValue,
        url: categoryData ? categoryData.url : '',
        displayOrder: categoryData ? categoryData.displayOrder : '',
        isActive: categoryData ? categoryData.isActive : '',
      };
      this.headerLabel = type === "button" ? categoryData.value : "Edit Tag Line"
      this.displayDeleteButton = true;
    },
    closeNetworkHeaderDialog() {
      this.isSaveInProgress = false;
      this.networkHeaderEditDialog = false;
      this.deleteTriggered = false;
      this.networkContentEditModel = getNetworkContentModel();
    },
    saveContent() {
      this.isSaveInProgress = true;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailPattern.test(this.networkContentEditModel.url) && !this.networkContentEditModel.url.startsWith('mailto:')) {
        this.networkContentEditModel.url = `mailto:${this.networkContentEditModel.url}`;
      }
      const saveData = { ...this.networkContentEditModel };
      this.saveYpoNetworkCategories(saveData)
          .then(() => {
            this.isSaveInProgress = false;
            this.getNetworkPageContent(this.$route.params.communityId);
            this.closeNetworkHeaderDialog();
          })
          .catch(() => {
            this.isSaveInProgress = false;
            this.getNetworkPageContent(this.$route.params.communityId);
            this.closeNetworkHeaderDialog();
          });
    },
    getCategoryId(categoryName) {
      if (this.networkPageContent && Array.isArray(this.networkPageContent.networkPageCategories)) {
        const category = this.networkPageContent.networkPageCategories.find(category => 
          category.value.toLowerCase() === categoryName.toLowerCase()
        );
        return category ? category.categoryId : null;
      }
      return null;
    },
    getCommunityTagLine() {
      if (this.canEditContent) {
        return this.networkPageContent && this.networkPageContent.communityTagLine && this.networkPageContent.communityTagLine.value
          ? this.networkPageContent.communityTagLine.value
          : NetworkConstants.ADD_NETWORK_DESCRIPTION;
      }
      return this.networkPageContent && this.networkPageContent.communityTagLine && this.networkPageContent.communityTagLine.value
        ? this.networkPageContent.communityTagLine.value
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.network_header {
  position: relative;
  &__breadcrumb {
    color: #041e42 !important;
    font-weight: bold;
    font-size: 24px;
    
    &--name {
      color: #083050 !important;
      font-weight: bold;
      font-size: 24px;
    }
  }

  &__header {
    align-content: center;
    justify-content: center;

    @include breakpoint(xs){
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 20px;
    }
    @include breakpoint(sm){
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 15px;
    }
    &--name {
      color: $ypo-black-opac;
      font-family: "Raleway", sans-serif;
      font-weight: bold;
      font-size: 24px;
    }


    &--tagline {
      color: $ypo-black-opac;
      font-family: "Raleway", sans-serif;
      font-size: 16px;
      padding: 0 25px;
      position: relative;
      font-weight: 500;

      @include breakpoint(xs){
        text-align: left;
        padding: 0;
      }
      @include breakpoint(sm){
        text-align: left;
        padding: 0;
      }

      .edit-desc{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .edit-icon {
        font-size: 12px !important;
        cursor: pointer;
        position: absolute;
        display: none;
        color: $ypo-gray !important;
        right: 5px;
        top: 0;

        &:hover {
          color: $ypo-cta !important;
        }
      }
      &:hover .edit-icon {
        display: block;
        @include breakpoint(sm) {
          display: none;
        }
      }
    }

    &--btn {
      min-width: 100px;
      display: inline-flex;;
      align-items: center;
      position: relative;
      justify-content: center;
      @include breakpoint(xs){
        margin: 0;
      }
      @include breakpoint(sm){
        margin: 0;
      }
      .edit-btn {
        padding: 5px 25px !important;
        position: relative;
        display: flex;
        align-items: center;
        @include breakpoint(xs){
          margin-left: 0;
        }
        @include breakpoint(sm){
          padding: 5px 25px !important;
        }
      }
        .edit-icon {
        font-size: 12px !important;
        cursor: pointer;
        display: none;
        position: absolute;
        right: 10px;
          top: 10px;
        color: $ypo-medium-gray !important;
        z-index: 9;
        &:hover {
          color: $ypo-cta !important;
          }
        }

      &:hover .edit-icon {
        display: inline-block;
        color: $white !important;
        @include breakpoint(sm) {
          display: none;
        }
      }
    }
  }
}

  .categoryEdit-popup {
    .v-card__title {
      background-color: $ypo-tile-border;
      color: $ypo-blue;
      font-family: Raleway, "sans-serif";
      font-size: 24px;
      font-weight: 500;
      line-height: 30px;
      position: relative;
      i {
        color: $ypo-cta;
        position: absolute;
        right: 20px;
        cursor: pointer;
      }
    }

    .form-control {
      margin: 0 10px;
      min-height: 70px;
      position: relative;
    }

    .currently-work {
      position: absolute;
      right: 0;
    }

    .required-label {
      color: $ypo-blue;
      font-size: 14px;
      font-weight: bold;
      line-height: 24px;
      text-align: right;
      display: block;
    }

    .select-label {
      color: $ypo-blue;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;

      i {
        font-size: 18px;
        padding-left: 5px;
      }
    }

    .select-label-dateFeild {
      color: $ypo-blue;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      margin-left: 10px;

      i {
        font-size: 18px;
        padding-left: 5px;
      }
    }

    .error-label-enable {
      color: $ypo-red;
    }

    .error-label-disable {
      color: $ypo-blue;
    }

    h4 {
      color: $ypo-blue;
      font-family: Raleway, "sans-serif";
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin: 0 0 5px 10px;
    }

    .check-list {
      margin: 0 5px 10px 5px;
      border-bottom: 2px solid rgba($black, 0.2);
      padding: 10px 0 10px 0;
    }

    .row__list {
      margin-bottom: 20px;
    }

    .btn-row {
      padding: 0 0 30px 15px;
      @media (max-width: 767px) {
        .v-btn {
          padding: 7px 20px;
        }
      }
      @include breakpoint(xs) {
        padding: 10px 0 10px 0;
      }
    }

    .v-card__text {
      margin-right: 5px;
      width: auto;
    }

    .v-card__actions {
      border-top: 1px solid $ypo-medium-gray;
    }

    .details-view {
      color: $ypo-gray-text;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 30px;
      padding-top: 30px;
      border-top: 1px solid $ypo-medium-gray;

      &:first-child {
        border-top: none;
        padding-top: 0;
      }

      h6 {
        color: $ypo-blue;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        margin: 0 0 5px 0;

        i {
          color: $ypo-title-blue-gray;
          margin-left: 5px;
          cursor: pointer;
        }

        .note {
          font-size: 14px;
          color: $ypo-gray;
          font-weight: 500;
          margin: 0 0 0 15px;
        }
      }

      strong {
        margin-left: 20px;
        display: block;

        i {
          color: $ypo-title-blue-gray;
          cursor: pointer;
          margin-left: 5px;
        }
      }

      small {
        margin-left: 20px;
        font-size: 14px;
        display: block;
      }

      i {
        color: $ypo-title-blue-gray;
        font-size: 14px;
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .contact-edit {
      &__title {
        color: $ypo_blue;
        text-align: center;
        font-weight: 600;
        line-height: 16px;
        font-size: 12px;
        margin-bottom: 15px;
      }

      &__row {
        align-items: center;
        background: $ypo-light-gray-background;

        &:nth-child(2n + 1) {
          background: $white;
        }

        strong {
          display: block;
          text-align: right;
          margin-top: 20px;
          color: $ypo_blue;
        }
      }
    }

    .autocomplete {
      position: relative;

      .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid $white;
        height: 200px;
        overflow: auto;
        background: $ypo-extra-light-gray;
        position: absolute;
        z-index: 100;
        width: 100%;
      }

      .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;

        &.is-active,
        &:hover {
          background-color: $ypo-cta;
          color: $black;
        }
      }
    }

    .v-btn__content {
      text-transform: uppercase;
    }

    .save-to-profile {
      display: initial;
      color: $ypo_blue;
      margin-left: 15px;
      font-weight: bold;

      i {
        margin-right: 8px;
      }

      @include breakpoint(xs) {
        display: block;
        margin: 10px 0;
      }
    }

    .add-edit-btn {
      position: relative;

      .fa-plus-circle {
        position: absolute;
        left: 6px;
        bottom: 0;
        font-size: 9px !important;
        background: $white;
        border-radius: 50%;
        padding: 1px;
      }
    }
  }

</style>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.v-breadcrumbs {
  position: relative;
  z-index: 1;
  padding: 15px 25px;

  @include breakpoint(xs){
      padding: 15px 15px;
    }
    @include breakpoint(sm){
      padding: 15px 15px;
    }
  a {
    font-size: 18px !important;
    color: black;
    text-decoration: none !important;
    font-weight: 400;
    text-transform: capitalize;
    @include breakpoint(xs){
      font-weight: 800;
    }
    @include breakpoint(sm){
      font-weight: 800;
    }
    &[href] {
      color: rgba(#083050, 0.9) !important;
      text-transform: capitalize;
      font-weight: bold;
      font-size: 24px;
    }

    &.router-link-active {
      color: rgba(#083050, 0.5) !important;
      cursor: default;
      pointer-events: none;
      text-transform: capitalize;
    }
  }

  &__divider {
    color: #083050 !important;
    padding: 0 10px !important;
    font-size: 16px !important;
  }

  li {
    font-size: 18px !important;
    color: #083050 !important;
  }

  li:nth-child(even) {
    font-size: 16px !important;
    color: #083050 !important;
  }
}

::v-deep .v-breadcrumbs .v-breadcrumbs__divider {
  color: rgba(#083050, 0.9)  !important;
  font-weight: bold;
  font-size: 16px;
}
</style>
